/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const S3_PREFIX = "https://media.werz.at/community-assets/dissonans/"

// Mapped from Figma "WERZ - Community - DISSONANS" -> Community / Web (576:18822):
// Landing desktop (235:2068) / mobile (363:9081), Event (987:17150, 367:2839),
// Event / Tickets (235:8023). Square content container, flat rows split by #444444 dividers.
const DISSONANS: CommunityData = {
  code: "dissonans",
  inviteCode: "dissonans",
  name: "DISSONANS",
  thumbnail: "",
  favicon: "",
  defaultCurrency: "SEK",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/diss-080`,
  waitlist: false,
  socials: {},
  styles: {
    global: {
      counterColor: "#ffffff",
      werzLogoColor: "#ffffff",
      logo: {
        src: `${S3_PREFIX}web-logo.jpg`,
        styles: "w-[128px] h-[124px]",
      },
      alternativeLogo: {
        src: `${S3_PREFIX}web-alternative-logo.png`,
        styles: "w-[128px] h-[124px]",
      },
      modalWindow: {
        container: "",
        title: "",
        subtitle: "",
      },
      bgColor: "#000000",
      asideBg: "#000000",
      asideStyles: "!p-0 !gap-0 border-r border-[#444444]",
      contentBg: "#000000",
      contentBoxShadow: "",
      bgDesktop: `${S3_PREFIX}web-background.jpg`,
      bgMobile: `${S3_PREFIX}web-background-mobile.jpg`,
      nonMemberBg: `${S3_PREFIX}web-background-non-member.jpg`,
      mainFont: "font-['HelveticaNeueRegular'] tracking-[0.02em]",
      primaryButton:
        "bg-[#222222] border border-[#444444] rounded-[8px] px-[18px] py-[18px] !text-[#ffffff] font-['HelveticaCompressedRegular'] tracking-[0.02em] !text-[16px] uppercase text-left leading-[100%]",
      scrollArrow: {
        background: "#222222",
        color: "#ffffff",
      },
    },
    navigation: {
      iconsColor: "#ffffff",
      sideBarSeparator: "border-r-[1px] border-[#444444]",
      separator: "border-[#444444]",
      item: "font-['LEDLIGHTRegular'] text-[18px] text-[#ffffff] leading-[100%] gap-x-[10px] text-opacity-50 text-center border-b border-[#444444] !pl-0 !py-4",
      itemSelected: " !text-opacity-100",
    },
    communityLanding: {
      container: "!bg-[#000000] overflow-hidden !pt-0 !pb-4 sm:!pb-8",
      titles:
        "text-[#ffffff] font-['HelveticaCompressedRegular'] tracking-[0.02em] text-[32px] uppercase text-left leading-[100%]",
      emptyOrLoadingState:
        "!mx-4 sm:!mx-8 text-[#bdbdbd] font-['HelveticaNeueRegular'] tracking-[0.02em] text-[14px] text-left leading-[120%]",
      announcementsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b border-[#444444]",
        sectionTitle:
          "text-[#ffffff] font-['HelveticaCompressedRegular'] tracking-[0.02em] text-[32px] uppercase text-left leading-[100%] pl-4 sm:pl-8 !mb-4 sm:!mb-6",
        scrollMenu: {
          container: "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 gap-x-6",
          wrapper: "relative group",
          item: "w-fit",
        },
        item: {
          container:
            "min-w-[calc(100vw-48px)] sm:min-w-[256px] sm:max-w-[256px] overflow-hidden !bg-[#ffffff00]",
          mediaContainer: "w-full sm:w-[256px] relative overflow-hidden",
          media: "w-full !aspect-square object-cover",
          placeholderMedia: "w-full !aspect-square bg-gray-400",
          content: "flex flex-col px-0 pt-4 bg-transparent",
          title:
            "text-[#ffffff] font-['HelveticaCompressedRegular'] tracking-[0.02em] text-[24px] uppercase text-left leading-[100%]",
          subtitle:
            "text-[#bdbdbd] font-['HelveticaNeueRegular'] tracking-[0.02em] text-[14px] text-left leading-[120%] mt-2",
        },
      },
      eventsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b border-[#444444]",
        sectionTitle:
          "text-[#ffffff] font-['HelveticaCompressedRegular'] tracking-[0.02em] text-[32px] uppercase text-left leading-[100%] pl-4 sm:pl-8 !mb-4 sm:!mb-6",
        scrollMenu: {
          container:
            "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 !h-full sm:!h-[128px] flex-row gap-6",
          wrapper: "relative group w-full",
          item: "w-fit",
        },
        item: {
          container:
            "flex sm:flex-row flex-col w-[calc(100vw-56px)] sm:!w-[420px] h-full overflow-hidden !bg-[#ffffff00]",
          mediaContainer: "w-full sm:!w-[228px] sm:flex-shrink-0 relative overflow-hidden",
          media: "w-full !aspect-video object-cover",
          placeholderMedia: "w-full !aspect-video bg-gray-400",
          content: "flex flex-col px-0 sm:pl-3 sm:pr-0 pt-4 sm:!pt-0 bg-transparent",
          title:
            "text-[#ffffff] font-['HelveticaCompressedRegular'] tracking-[0.02em] text-[24px] sm:text-[18px] uppercase text-left leading-[100%]",
          subtitle:
            "text-[#bdbdbd] font-['HelveticaNeueRegular'] tracking-[0.02em] text-[14px] sm:text-[12px] text-left leading-[120%] mt-2",
          location:
            "text-[#bdbdbd] font-['HelveticaNeueRegular'] tracking-[0.02em] text-[14px] sm:text-[12px] text-left leading-[120%] mt-1",
          date: "text-[#bdbdbd] font-['HelveticaNeueRegular'] tracking-[0.02em] text-[14px] sm:text-[12px] text-left leading-[120%] mt-2",
        },
      },
      shop: {
        container: "py-4 sm:py-8 !m-0 space-y-0 !border-0 overflow-hidden",
        title:
          "text-[#ffffff] font-['HelveticaCompressedRegular'] tracking-[0.02em] text-[28px] uppercase text-left leading-[100%]",
        text: "text-[#d5d5d5] font-['HelveticaNeueRegular'] tracking-[0.02em] text-[16px] text-left leading-[120%]",
        // Component hardcodes 456x288; Figma is 420x236 desktop, full-width 16:9 mobile.
        customShopImageStyle: "!h-auto !aspect-video sm:!w-[420px]",
        sectionTitle:
          "text-[#ffffff] font-['HelveticaCompressedRegular'] tracking-[0.02em] text-[32px] uppercase text-left leading-[100%] !mb-4 sm:!mb-6",
      },
    },
    eventV2: {
      container: "flex flex-col !bg-[#000000] overflow-hidden !pb-4 sm:!pb-8",
      eventInfo: {
        container: "flex flex-col sm:flex-row gap-4 sm:gap-8 sm:p-8 p-4 border-b border-[#444444]",
        media: "!w-full sm:!w-[320px] !h-auto !aspect-video object-cover sm:mb-4 !border-0",
        title:
          "text-[#ffffff] font-['HelveticaCompressedRegular'] tracking-[0.02em] text-[28px] sm:text-[32px] uppercase text-left leading-[100%]",
        subtitle:
          "text-[#bdbdbd] font-['HelveticaNeueRegular'] tracking-[0.02em] text-[14px] text-left leading-[120%] mb-4 mt-2",
        button:
          "bg-[#222222] border border-[#444444] rounded-[8px] px-[18px] py-[18px] !w-fit mb-4 sm:mb-0 gap-y-[6px] text-[#ffffff] font-['HelveticaCompressedRegular'] tracking-[0.02em] !text-[16px] uppercase text-left leading-[100%]",
        questions: "text-[14px] leading-[120%] text-left !text-[#bdbdbd]",
      },
      about: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-[#444444]",
        header:
          "text-[#ffffff] font-['HelveticaCompressedRegular'] tracking-[0.02em] text-[28px] uppercase text-left leading-[100%]",
        text: "text-[#d5d5d5] font-['HelveticaNeueRegular'] tracking-[0.02em] text-[14px] text-left leading-[120%] w-full",
      },
      location: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-[#444444]",
        header:
          "text-[#ffffff] font-['HelveticaCompressedRegular'] tracking-[0.02em] text-[28px] uppercase text-left leading-[100%]",
        text: "text-[#d5d5d5] font-['HelveticaNeueRegular'] tracking-[0.02em] text-[14px] text-left leading-[120%] max-w-[652px] w-full",
        // Wrappers hardcode 307x204 / 309x206; Figma is 350x197 desktop, full-width 16:9 mobile.
        map: "!w-full sm:!w-[350px] !h-auto !aspect-video overflow-hidden",
        mapPinColor: "#ffffff",
        mapStrokeColor: "#ffffff00",
      },
      downloadWERZ: {
        container: "flex flex-col gap-4 sm:gap-6 sm:p-8 p-4",
        header:
          "text-[#ffffff] font-['HelveticaCompressedRegular'] tracking-[0.02em] text-[28px] uppercase text-left leading-[100%]",
        text: "text-[#d5d5d5] font-['HelveticaNeueRegular'] tracking-[0.02em] text-[16px] text-left leading-[120%]",
      },
      tickets: {
        // First ticket's py-4 adds 16px, so mb-2 lands on Figma's 24px header gap on desktop.
        header:
          "text-[#ffffff] font-['HelveticaCompressedRegular'] tracking-[0.02em] text-[28px] uppercase text-left leading-[100%] px-4 sm:px-8 pt-4 sm:pt-8 mb-0 sm:mb-2 flex justify-between items-center",
        outerContainer: "flex flex-col !bg-[#000000] !pb-4 sm:!pb-8",
        innerContainer: "flex flex-col overflow-hidden px-4 sm:px-8",
        accessCode: {
          button:
            "bg-[#000000] border border-[#6d6d6d] rounded-[8px] px-[12px] py-[12px] text-[#ffffff] font-['HelveticaCompressedRegular'] tracking-[0.02em] text-[14px] uppercase text-left leading-[100%] !w-fit",
        },
        ticket: {
          container:
            "flex flex-row justify-between gap-x-4 leading-auto !bg-[#ffffff00] border-b border-[#444444] overflow-hidden py-4",
          mediaContainer: "!hidden",
          media: "!hidden",
          name: "text-[#ffffff] font-['HelveticaCompressedRegular'] tracking-[0.02em] text-[18px] uppercase text-left leading-[100%] mb-1",
          description:
            "text-[#bdbdbd] font-['HelveticaNeueRegular'] tracking-[0.02em] text-[14px] text-left leading-[120%] mb-1 flex flex-row gap-x-1",
          price:
            "text-[#bdbdbd] font-['HelveticaCompressedRegular'] tracking-[0.02em] text-[18px] uppercase text-left leading-[100%]",
          quantity:
            "text-[#ffffff] font-['HelveticaCompressedRegular'] tracking-[0.02em] text-[14px] uppercase text-left leading-[100%]",
          status:
            "text-[#bdbdbd] font-['HelveticaCompressedRegular'] tracking-[0.02em] text-[18px] uppercase text-left leading-[100%]",
          counterContainer:
            "bg-[#000000] border border-[#6d6d6d] rounded-[8px] px-[12px] py-[12px] gap-x-[16px] !w-fit !h-9",
          plusMinusColor: "#ffffff",
          button:
            "bg-[#000000] border border-[#6d6d6d] rounded-[8px] px-[12px] py-[12px] text-[#ffffff] font-['HelveticaCompressedRegular'] tracking-[0.02em] text-[14px] uppercase text-left leading-[100%] !w-fit",
          descriptionCutoff: 30,
        },
      },
    },
  },
}

export default DISSONANS
